export const ProductosMasVisitados = [
  {
    nombreProducto: 'Remera Miley Cyrus',
    nombreLocal: 'HannahMontana',
    codProducto: '091218R',
    codLocal: '091218P',
    cantidad: 4567,
    urlImagen: 'https://img.avellanedaaltoque.com/productos/2324287/1oer_thumb.jpg'
  },
  {
    nombreProducto: 'Zapatos',
    nombreLocal: 'JOY BOY',
    codProducto: 'PHG5346',
    codLocal: 'PHG5346',
    cantidad: 123,
    urlImagen: 'https://img.avellanedaaltoque.com/productos/3154383/1mwf_thumb.jpg'
  },
  {
    nombreProducto: 'Remera',
    nombreLocal: 'GOL',
    codProducto: '997JKLO',
    codLocal: '997JKLO',
    cantidad: 987,
    urlImagen: 'https://img.avellanedaaltoque.com/productos/3102341/1jwe_thumb.jpg'
  },
  {
    nombreProducto: 'Pollera',
    nombreLocal: 'Fito 21',
    codProducto: '987K45G',
    codLocal: '987K45G',
    cantidad: 721,
    urlImagen: 'https://img.avellanedaaltoque.com/productos/3185645/1omg_thumb.jpg'
  }
]

export const cluster = [
  {
    idTenant: 1,
    cluster: 'bikini',
    hits: 5741,
    metadata: null,
    termsList: [
      {
        term: 'bikini',
        hits: 5533,
        metadata: null
      },
      {
        term: 'bikini top',
        hits: 79,
        metadata: null
      },
      {
        term: 'bikinis',
        hits: 70,
        metadata: null
      },
      {
        term: 'bikini strapl',
        hits: 21,
        metadata: null
      },
      {
        term: 'set bikini',
        hits: 19,
        metadata: null
      },
      {
        term: 'top bikini',
        hits: 19,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'malla',
    hits: 3550,
    metadata: null,
    termsList: [
      {
        term: 'malla',
        hits: 2694,
        metadata: null
      },
      {
        term: 'malla enteriza',
        hits: 634,
        metadata: null
      },
      {
        term: 'malla entero',
        hits: 111,
        metadata: null
      },
      {
        term: 'malla especial',
        hits: 68,
        metadata: null
      },
      {
        term: 'malla importado',
        hits: 43,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'mochila',
    hits: 3096,
    metadata: null,
    termsList: [
      {
        term: 'mochila',
        hits: 3015,
        metadata: null
      },
      {
        term: 'set mochila',
        hits: 45,
        metadata: null
      },
      {
        term: 'set de mochila',
        hits: 20,
        metadata: null
      },
      {
        term: 'mochilo set',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'musculosa',
    hits: 2449,
    metadata: null,
    termsList: [
      {
        term: 'musculosa',
        hits: 1708,
        metadata: null
      },
      {
        term: 'musculosa algodon',
        hits: 100,
        metadata: null
      },
      {
        term: 'musculosa oversize',
        hits: 75,
        metadata: null
      },
      {
        term: 'musculosa afa',
        hits: 60,
        metadata: null
      },
      {
        term: 'musculosa modal',
        hits: 49,
        metadata: null
      },
      {
        term: 'vestido musculosa',
        hits: 49,
        metadata: null
      },
      {
        term: 'musculosa con puntilla',
        hits: 44,
        metadata: null
      },
      {
        term: 'musculosa puntilla',
        hits: 44,
        metadata: null
      },
      {
        term: 'musculosa liso',
        hits: 42,
        metadata: null
      },
      {
        term: 'body musculosa',
        hits: 30,
        metadata: null
      },
      {
        term: 'musculosa talle especial',
        hits: 30,
        metadata: null
      },
      {
        term: 'top musculosa',
        hits: 29,
        metadata: null
      },
      {
        term: 'musculosa especial',
        hits: 25,
        metadata: null
      },
      {
        term: 'musculosa tirita',
        hits: 25,
        metadata: null
      },
      {
        term: 'musculosa top',
        hits: 24,
        metadata: null
      },
      {
        term: 'musculosa tejida',
        hits: 22,
        metadata: null
      },
      {
        term: 'mosculosa',
        hits: 21,
        metadata: null
      },
      {
        term: 'musculosa alo',
        hits: 20,
        metadata: null
      },
      {
        term: 'musculosa nena',
        hits: 19,
        metadata: null
      },
      {
        term: 'musculosa bretel',
        hits: 17,
        metadata: null
      },
      {
        term: 'musculosa corta',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'vestido de fiesta',
    hits: 2057,
    metadata: null,
    termsList: [
      {
        term: 'vestido de fiesta',
        hits: 1297,
        metadata: null
      },
      {
        term: 'vestido fiesta',
        hits: 137,
        metadata: null
      },
      {
        term: 'fiesta',
        hits: 98,
        metadata: null
      },
      {
        term: 'vestido de fiesta largo',
        hits: 72,
        metadata: null
      },
      {
        term: 'misi vestido de fiesta',
        hits: 71,
        metadata: null
      },
      {
        term: 'vestido de fiesta corto',
        hits: 62,
        metadata: null
      },
      {
        term: 'ropa de fiesta',
        hits: 60,
        metadata: null
      },
      {
        term: 'vestido largo de fiesta',
        hits: 57,
        metadata: null
      },
      {
        term: 'zapato de fiesta',
        hits: 40,
        metadata: null
      },
      {
        term: 'vestido largo fiesta',
        hits: 27,
        metadata: null
      },
      {
        term: 'vestido corto de fiesta',
        hits: 25,
        metadata: null
      },
      {
        term: 'conjunto de fiesta',
        hits: 20,
        metadata: null
      },
      {
        term: 'monito de fiesta',
        hits: 20,
        metadata: null
      },
      {
        term: 'remera de fiesta',
        hits: 20,
        metadata: null
      },
      {
        term: 'vestido para fiesta',
        hits: 18,
        metadata: null
      },
      {
        term: 'vestido de fiesta nena',
        hits: 17,
        metadata: null
      },
      {
        term: 'sobre de fiesta',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'bermuda',
    hits: 2046,
    metadata: null,
    termsList: [
      {
        term: 'bermuda',
        hits: 915,
        metadata: null
      },
      {
        term: 'bermuda de jean',
        hits: 284,
        metadata: null
      },
      {
        term: 'bermuda jean',
        hits: 114,
        metadata: null
      },
      {
        term: 'bermuda de hombre',
        hits: 70,
        metadata: null
      },
      {
        term: 'bermuda de lino',
        hits: 70,
        metadata: null
      },
      {
        term: 'bermuda hombre',
        hits: 66,
        metadata: null
      },
      {
        term: 'bermuda lino',
        hits: 59,
        metadata: null
      },
      {
        term: 'bermuda jean hombre',
        hits: 58,
        metadata: null
      },
      {
        term: 'bermuda algodon',
        hits: 50,
        metadata: null
      },
      {
        term: 'bermuda rustico',
        hits: 50,
        metadata: null
      },
      {
        term: 'bermuda de jean hombre',
        hits: 49,
        metadata: null
      },
      {
        term: 'bermuda sastrero',
        hits: 48,
        metadata: null
      },
      {
        term: 'bermuda dama',
        hits: 39,
        metadata: null
      },
      {
        term: 'bermuda de baño',
        hits: 36,
        metadata: null
      },
      {
        term: 'bermuda de algodon',
        hits: 33,
        metadata: null
      },
      {
        term: 'bermuda talle especial',
        hits: 31,
        metadata: null
      },
      {
        term: 'bermuda amiri',
        hits: 22,
        metadata: null
      },
      {
        term: 'bermuda de fibran',
        hits: 18,
        metadata: null
      },
      {
        term: 'bermuda lino hombre',
        hits: 18,
        metadata: null
      },
      {
        term: 'bermuda camuflado',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'lino',
    hits: 2044,
    metadata: null,
    termsList: [
      {
        term: 'lino',
        hits: 382,
        metadata: null
      },
      {
        term: 'pantalon de lino',
        hits: 246,
        metadata: null
      },
      {
        term: 'conjunto lino',
        hits: 225,
        metadata: null
      },
      {
        term: 'conjunto de lino',
        hits: 196,
        metadata: null
      },
      {
        term: 'vestido lino',
        hits: 191,
        metadata: null
      },
      {
        term: 'pantalon lino',
        hits: 189,
        metadata: null
      },
      {
        term: 'vestido de lino',
        hits: 180,
        metadata: null
      },
      {
        term: 'palazo de lino',
        hits: 88,
        metadata: null
      },
      {
        term: 'palazo lino',
        hits: 84,
        metadata: null
      },
      {
        term: 'monito de lino',
        hits: 46,
        metadata: null
      },
      {
        term: 'pollera lino',
        hits: 42,
        metadata: null
      },
      {
        term: 'pollera de lino',
        hits: 32,
        metadata: null
      },
      {
        term: 'capri de lino',
        hits: 27,
        metadata: null
      },
      {
        term: 'enterito de lino',
        hits: 26,
        metadata: null
      },
      {
        term: 'remera de lino',
        hits: 20,
        metadata: null
      },
      {
        term: 'remera lino',
        hits: 19,
        metadata: null
      },
      {
        term: 'monito lino',
        hits: 17,
        metadata: null
      },
      {
        term: 'sastrero lino',
        hits: 17,
        metadata: null
      },
      {
        term: 'vestido lino corto',
        hits: 17,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'vestido',
    hits: 2027,
    metadata: null,
    termsList: [
      {
        term: 'vestido',
        hits: 1991,
        metadata: null
      },
      {
        term: 'vestido print',
        hits: 36,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'guardapolvo',
    hits: 1884,
    metadata: null,
    termsList: [
      {
        term: 'guardapolvo',
        hits: 1405,
        metadata: null
      },
      {
        term: 'guardapolvo jardin',
        hits: 82,
        metadata: null
      },
      {
        term: 'guardapolvo azul',
        hits: 81,
        metadata: null
      },
      {
        term: 'guardapolvo arciel',
        hits: 75,
        metadata: null
      },
      {
        term: 'guardapolvo de jardin',
        hits: 70,
        metadata: null
      },
      {
        term: 'guardapolvo escolar',
        hits: 49,
        metadata: null
      },
      {
        term: 'guardapolvo maestra',
        hits: 28,
        metadata: null
      },
      {
        term: 'guardapolvo pechera',
        hits: 27,
        metadata: null
      },
      {
        term: 'guardapolvo tecnico',
        hits: 26,
        metadata: null
      },
      {
        term: 'guardapolvo nena',
        hits: 23,
        metadata: null
      },
      {
        term: 'guardapolvo con broche',
        hits: 18,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'util escolar',
    hits: 1817,
    metadata: null,
    termsList: [
      {
        term: 'util escolar',
        hits: 789,
        metadata: null
      },
      {
        term: 'escolar',
        hits: 452,
        metadata: null
      },
      {
        term: 'pechera escolar',
        hits: 164,
        metadata: null
      },
      {
        term: 'remera escolar',
        hits: 150,
        metadata: null
      },
      {
        term: 'pechero escolar',
        hits: 83,
        metadata: null
      },
      {
        term: 'ropa escolar',
        hits: 74,
        metadata: null
      },
      {
        term: 'camisa escolar',
        hits: 33,
        metadata: null
      },
      {
        term: 'campera escolar',
        hits: 25,
        metadata: null
      },
      {
        term: 'cosa escolar',
        hits: 25,
        metadata: null
      },
      {
        term: 'pollera escolar',
        hits: 22,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'short pollero',
    hits: 1778,
    metadata: null,
    termsList: [
      {
        term: 'short pollero',
        hits: 1429,
        metadata: null
      },
      {
        term: 'pollero short',
        hits: 87,
        metadata: null
      },
      {
        term: 'short pollera volado',
        hits: 79,
        metadata: null
      },
      {
        term: 'short pollera',
        hits: 42,
        metadata: null
      },
      {
        term: 'short pollera especial',
        hits: 41,
        metadata: null
      },
      {
        term: 'short pollero cey',
        hits: 25,
        metadata: null
      },
      {
        term: 'short pollero con volado',
        hits: 25,
        metadata: null
      },
      {
        term: 'conjunto short pollero',
        hits: 18,
        metadata: null
      },
      {
        term: 'short pollero azul',
        hits: 16,
        metadata: null
      },
      {
        term: 'short-pollera',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'sandalia',
    hits: 1752,
    metadata: null,
    termsList: [
      {
        term: 'sandalia',
        hits: 1583,
        metadata: null
      },
      {
        term: 'sandalia chatita',
        hits: 33,
        metadata: null
      },
      {
        term: 'sandalia nena',
        hits: 25,
        metadata: null
      },
      {
        term: 'sandalia importado',
        hits: 24,
        metadata: null
      },
      {
        term: 'ojota sandalia',
        hits: 23,
        metadata: null
      },
      {
        term: 'sandalia bebe',
        hits: 23,
        metadata: null
      },
      {
        term: 'sandalia ojota',
        hits: 23,
        metadata: null
      },
      {
        term: 'sandalia tacha',
        hits: 18,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'vestido playero',
    hits: 1641,
    metadata: null,
    termsList: [
      {
        term: 'vestido playero',
        hits: 688,
        metadata: null
      },
      {
        term: 'conjunto playero',
        hits: 550,
        metadata: null
      },
      {
        term: 'playero',
        hits: 285,
        metadata: null
      },
      {
        term: 'pantalon playero',
        hits: 73,
        metadata: null
      },
      {
        term: 'pareo playero',
        hits: 27,
        metadata: null
      },
      {
        term: 'remeron playero',
        hits: 18,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'conjunto',
    hits: 1627,
    metadata: null,
    termsList: [
      {
        term: 'conjunto',
        hits: 1429,
        metadata: null
      },
      {
        term: 'conjunto nena',
        hits: 49,
        metadata: null
      },
      {
        term: 'conjunto de nena',
        hits: 39,
        metadata: null
      },
      {
        term: 'conjunto nene',
        hits: 37,
        metadata: null
      },
      {
        term: 'conjunto irun',
        hits: 28,
        metadata: null
      },
      {
        term: 'conjunto de nene',
        hits: 25,
        metadata: null
      },
      {
        term: 'conjunto especial',
        hits: 20,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'zapatilla',
    hits: 1589,
    metadata: null,
    termsList: [
      {
        term: 'zapatilla',
        hits: 879,
        metadata: null
      },
      {
        term: 'zapatilla importado',
        hits: 398,
        metadata: null
      },
      {
        term: 'zapatilla irun',
        hits: 67,
        metadata: null
      },
      {
        term: 'zapatilla mujer',
        hits: 62,
        metadata: null
      },
      {
        term: 'zapatilla campus',
        hits: 33,
        metadata: null
      },
      {
        term: 'zapatilla urbano',
        hits: 29,
        metadata: null
      },
      {
        term: 'zapatilla de mujer',
        hits: 27,
        metadata: null
      },
      {
        term: 'zapatilla de lona',
        hits: 22,
        metadata: null
      },
      {
        term: 'zapatilla elastizada',
        hits: 21,
        metadata: null
      },
      {
        term: 'zapatilla lona',
        hits: 18,
        metadata: null
      },
      {
        term: 'zapatilla elastizado',
        hits: 17,
        metadata: null
      },
      {
        term: 'zapatilla cuero',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'vestido largo',
    hits: 1537,
    metadata: null,
    termsList: [
      {
        term: 'vestido largo',
        hits: 888,
        metadata: null
      },
      {
        term: 'pollera largo',
        hits: 558,
        metadata: null
      },
      {
        term: 'largo',
        hits: 35,
        metadata: null
      },
      {
        term: 'pareo largo',
        hits: 24,
        metadata: null
      },
      {
        term: 'remera largo',
        hits: 16,
        metadata: null
      },
      {
        term: 'vestido saten largo',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'remera',
    hits: 1511,
    metadata: null,
    termsList: [
      {
        term: 'remera',
        hits: 1045,
        metadata: null
      },
      {
        term: 'remera sol',
        hits: 95,
        metadata: null
      },
      {
        term: 'remera nena',
        hits: 55,
        metadata: null
      },
      {
        term: 'remera para sublimar',
        hits: 46,
        metadata: null
      },
      {
        term: 'remera de nena',
        hits: 43,
        metadata: null
      },
      {
        term: 'remera negra',
        hits: 39,
        metadata: null
      },
      {
        term: 'remera termico',
        hits: 37,
        metadata: null
      },
      {
        term: 'remera especial',
        hits: 34,
        metadata: null
      },
      {
        term: 'remera nene',
        hits: 31,
        metadata: null
      },
      {
        term: 'remera alo',
        hits: 27,
        metadata: null
      },
      {
        term: 'remera sublimada',
        hits: 24,
        metadata: null
      },
      {
        term: 'remera tul',
        hits: 19,
        metadata: null
      },
      {
        term: 'remera termica',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'ojota',
    hits: 1410,
    metadata: null,
    termsList: [
      {
        term: 'ojota',
        hits: 1334,
        metadata: null
      },
      {
        term: 'ojota faja',
        hits: 47,
        metadata: null
      },
      {
        term: 'ojota damo',
        hits: 29,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'short',
    hits: 1408,
    metadata: null,
    termsList: [
      {
        term: 'short',
        hits: 1196,
        metadata: null
      },
      {
        term: 'short microfibro',
        hits: 55,
        metadata: null
      },
      {
        term: 'mini short',
        hits: 52,
        metadata: null
      },
      {
        term: 'short especial',
        hits: 30,
        metadata: null
      },
      {
        term: 'short modal',
        hits: 25,
        metadata: null
      },
      {
        term: 'short niño',
        hits: 18,
        metadata: null
      },
      {
        term: 'micro short',
        hits: 16,
        metadata: null
      },
      {
        term: 'short sublimado',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'top',
    hits: 1376,
    metadata: null,
    termsList: [
      {
        term: 'top',
        hits: 940,
        metadata: null
      },
      {
        term: 'tops',
        hits: 417,
        metadata: null
      },
      {
        term: 'top alo',
        hits: 19,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'remeron',
    hits: 1295,
    metadata: null,
    termsList: [
      {
        term: 'remeron',
        hits: 678,
        metadata: null
      },
      {
        term: 'remera oversize',
        hits: 525,
        metadata: null
      },
      {
        term: 'remera over',
        hits: 51,
        metadata: null
      },
      {
        term: 'remera boss',
        hits: 22,
        metadata: null
      },
      {
        term: 'remera overside',
        hits: 19,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'argentino',
    hits: 1293,
    metadata: null,
    termsList: [
      {
        term: 'argentino',
        hits: 382,
        metadata: null
      },
      {
        term: 'remera argentino',
        hits: 377,
        metadata: null
      },
      {
        term: 'buzo argentino',
        hits: 356,
        metadata: null
      },
      {
        term: 'top argentino',
        hits: 35,
        metadata: null
      },
      {
        term: 'conjunto argentino',
        hits: 34,
        metadata: null
      },
      {
        term: 'seleccion argentino',
        hits: 30,
        metadata: null
      },
      {
        term: 'gorra argentino',
        hits: 26,
        metadata: null
      },
      {
        term: 'mochila argentino',
        hits: 19,
        metadata: null
      },
      {
        term: 'bandera argentino',
        hits: 17,
        metadata: null
      },
      {
        term: 'campera argentino',
        hits: 17,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'jean',
    hits: 1192,
    metadata: null,
    termsList: [
      {
        term: 'jean',
        hits: 1176,
        metadata: null
      },
      {
        term: 'jean nena',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'bikini con aro',
    hits: 1168,
    metadata: null,
    termsList: [
      {
        term: 'bikini con aro',
        hits: 127,
        metadata: null
      },
      {
        term: 'bikini nena',
        hits: 121,
        metadata: null
      },
      {
        term: 'bikini armado',
        hits: 107,
        metadata: null
      },
      {
        term: 'bikini combinado',
        hits: 83,
        metadata: null
      },
      {
        term: 'bikini especial',
        hits: 79,
        metadata: null
      },
      {
        term: 'bikini vedetina',
        hits: 60,
        metadata: null
      },
      {
        term: 'bikini estrella',
        hits: 51,
        metadata: null
      },
      {
        term: 'bikini aro',
        hits: 44,
        metadata: null
      },
      {
        term: 'bikini juvenil',
        hits: 36,
        metadata: null
      },
      {
        term: 'bikini de nena',
        hits: 34,
        metadata: null
      },
      {
        term: 'bikini cuadrille',
        hits: 33,
        metadata: null
      },
      {
        term: 'bikini hebilla',
        hits: 31,
        metadata: null
      },
      {
        term: 'bikini armadas',
        hits: 30,
        metadata: null
      },
      {
        term: 'bikini con pollera',
        hits: 29,
        metadata: null
      },
      {
        term: 'bikini tendencia',
        hits: 27,
        metadata: null
      },
      {
        term: 'bikini con pareo',
        hits: 23,
        metadata: null
      },
      {
        term: 'bikini texturado',
        hits: 22,
        metadata: null
      },
      {
        term: 'corpiño bikini',
        hits: 22,
        metadata: null
      },
      {
        term: 'corpiño de bikini',
        hits: 22,
        metadata: null
      },
      {
        term: 'bikini azul',
        hits: 21,
        metadata: null
      },
      {
        term: 'bikini con vedetina',
        hits: 21,
        metadata: null
      },
      {
        term: 'bikini volado',
        hits: 20,
        metadata: null
      },
      {
        term: 'bikini cruzado',
        hits: 19,
        metadata: null
      },
      {
        term: 'bikini pollera',
        hits: 19,
        metadata: null
      },
      {
        term: 'todointimo - bikini',
        hits: 19,
        metadata: null
      },
      {
        term: 'bikini dama',
        hits: 18,
        metadata: null
      },
      {
        term: 'bikini con dije',
        hits: 17,
        metadata: null
      },
      {
        term: 'bikini de dama',
        hits: 17,
        metadata: null
      },
      {
        term: 'bikini estampado',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'conjunto deportivo',
    hits: 1150,
    metadata: null,
    termsList: [
      {
        term: 'conjunto deportivo',
        hits: 971,
        metadata: null
      },
      {
        term: 'conjunto deportivo hombre',
        hits: 98,
        metadata: null
      },
      {
        term: 'ropa deportivo hombre',
        hits: 47,
        metadata: null
      },
      {
        term: 'conjunto deportivo de hombre',
        hits: 34,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'remera mujer',
    hits: 1138,
    metadata: null,
    termsList: [
      {
        term: 'remera mujer',
        hits: 141,
        metadata: null
      },
      {
        term: 'chaleco de mujer',
        hits: 135,
        metadata: null
      },
      {
        term: 'conjunto mujer',
        hits: 110,
        metadata: null
      },
      {
        term: 'bermudo mujer',
        hits: 93,
        metadata: null
      },
      {
        term: 'conjunto de mujer',
        hits: 68,
        metadata: null
      },
      {
        term: 'vestido mujer',
        hits: 68,
        metadata: null
      },
      {
        term: 'ojota mujer',
        hits: 67,
        metadata: null
      },
      {
        term: 'remera de mujer',
        hits: 58,
        metadata: null
      },
      {
        term: 'remeron mujer',
        hits: 49,
        metadata: null
      },
      {
        term: 'remera algodon mujer',
        hits: 43,
        metadata: null
      },
      {
        term: 'zapato mujer',
        hits: 37,
        metadata: null
      },
      {
        term: 'vestido de mujer',
        hits: 35,
        metadata: null
      },
      {
        term: 'bota de mujer',
        hits: 31,
        metadata: null
      },
      {
        term: 'ojota de mujer',
        hits: 27,
        metadata: null
      },
      {
        term: 'cinto de mujer',
        hits: 24,
        metadata: null
      },
      {
        term: 'remera oversize mujer',
        hits: 24,
        metadata: null
      },
      {
        term: 'remera de algodon mujer',
        hits: 23,
        metadata: null
      },
      {
        term: 'cinto mujer',
        hits: 22,
        metadata: null
      },
      {
        term: 'pantalon de vestir mujer',
        hits: 21,
        metadata: null
      },
      {
        term: 'pantalon mujer',
        hits: 21,
        metadata: null
      },
      {
        term: 'remeron de mujer',
        hits: 21,
        metadata: null
      },
      {
        term: 'pantalon sastrero mujer',
        hits: 20,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'pantalon sastrero',
    hits: 1135,
    metadata: null,
    termsList: [
      {
        term: 'pantalon sastrero',
        hits: 508,
        metadata: null
      },
      {
        term: 'pantalon',
        hits: 173,
        metadata: null
      },
      {
        term: 'pantalon de vestir',
        hits: 158,
        metadata: null
      },
      {
        term: 'pantalon fibran',
        hits: 37,
        metadata: null
      },
      {
        term: 'pantalon engomado',
        hits: 35,
        metadata: null
      },
      {
        term: 'pantalon rompeviento',
        hits: 35,
        metadata: null
      },
      {
        term: 'pantalon de fibran',
        hits: 33,
        metadata: null
      },
      {
        term: 'pantalon corto',
        hits: 32,
        metadata: null
      },
      {
        term: 'pantalon recto',
        hits: 28,
        metadata: null
      },
      {
        term: 'pantalon palazo',
        hits: 21,
        metadata: null
      },
      {
        term: 'pantalon vestir',
        hits: 21,
        metadata: null
      },
      {
        term: 'pantalon especial',
        hits: 20,
        metadata: null
      },
      {
        term: 'pantalon elt',
        hits: 18,
        metadata: null
      },
      {
        term: 'pantalon jean',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'short sastrero',
    hits: 1118,
    metadata: null,
    termsList: [
      {
        term: 'short tiro bajo',
        hits: 318,
        metadata: null
      },
      {
        term: 'short sastrero',
        hits: 313,
        metadata: null
      },
      {
        term: 'short hombre',
        hits: 133,
        metadata: null
      },
      {
        term: 'short de hombre',
        hits: 66,
        metadata: null
      },
      {
        term: 'short pollero sastrero',
        hits: 63,
        metadata: null
      },
      {
        term: 'short potrero',
        hits: 38,
        metadata: null
      },
      {
        term: 'short volado',
        hits: 37,
        metadata: null
      },
      {
        term: 'short fajo',
        hits: 31,
        metadata: null
      },
      {
        term: 'short tiro alto',
        hits: 29,
        metadata: null
      },
      {
        term: 'short tiro medio',
        hits: 28,
        metadata: null
      },
      {
        term: 'short el loca',
        hits: 25,
        metadata: null
      },
      {
        term: 'short con volado',
        hits: 20,
        metadata: null
      },
      {
        term: 'short rustico hombre',
        hits: 17,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'short de jean',
    hits: 1105,
    metadata: null,
    termsList: [
      {
        term: 'short de jean',
        hits: 945,
        metadata: null
      },
      {
        term: 'short pollero de jean',
        hits: 88,
        metadata: null
      },
      {
        term: 'short de jean mujer',
        hits: 27,
        metadata: null
      },
      {
        term: 'short de jean elastizado',
        hits: 25,
        metadata: null
      },
      {
        term: 'short de jean especial',
        hits: 20,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'pollera',
    hits: 1072,
    metadata: null,
    termsList: [
      {
        term: 'pollera',
        hits: 732,
        metadata: null
      },
      {
        term: 'pollera pareo',
        hits: 117,
        metadata: null
      },
      {
        term: 'pollera pantalon',
        hits: 73,
        metadata: null
      },
      {
        term: 'pollera engomado',
        hits: 39,
        metadata: null
      },
      {
        term: 'pantalon pollera',
        hits: 35,
        metadata: null
      },
      {
        term: 'pollera tul',
        hits: 34,
        metadata: null
      },
      {
        term: 'pollera sastrera',
        hits: 23,
        metadata: null
      },
      {
        term: 'pollera cuadrille',
        hits: 19,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'gorra',
    hits: 1011,
    metadata: null,
    termsList: [
      {
        term: 'gorra',
        hits: 929,
        metadata: null
      },
      {
        term: 'gorra vintage',
        hits: 65,
        metadata: null
      },
      {
        term: 'gorra hombre',
        hits: 17,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'pijama',
    hits: 1009,
    metadata: null,
    termsList: [
      {
        term: 'pijama',
        hits: 746,
        metadata: null
      },
      {
        term: 'conjunto pijama',
        hits: 135,
        metadata: null
      },
      {
        term: 'pijama saten',
        hits: 65,
        metadata: null
      },
      {
        term: 'pijama hombre',
        hits: 38,
        metadata: null
      },
      {
        term: 'pijama de saten',
        hits: 25,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'ropa deportivo',
    hits: 1004,
    metadata: null,
    termsList: [
      {
        term: 'ropa deportivo',
        hits: 481,
        metadata: null
      },
      {
        term: 'calza deportivo',
        hits: 221,
        metadata: null
      },
      {
        term: 'campera deportivo',
        hits: 134,
        metadata: null
      },
      {
        term: 'camiseta deportivo',
        hits: 107,
        metadata: null
      },
      {
        term: 'pollera deportivo',
        hits: 61,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'mochila carrito',
    hits: 969,
    metadata: null,
    termsList: [
      {
        term: 'mochila carrito',
        hits: 699,
        metadata: null
      },
      {
        term: 'mochila con carrito',
        hits: 119,
        metadata: null
      },
      {
        term: 'mochilo de viaje',
        hits: 30,
        metadata: null
      },
      {
        term: 'mochila viaje',
        hits: 28,
        metadata: null
      },
      {
        term: 'mochila con carro',
        hits: 24,
        metadata: null
      },
      {
        term: 'mochila con rueda',
        hits: 23,
        metadata: null
      },
      {
        term: 'mochila con ruedita',
        hits: 23,
        metadata: null
      },
      {
        term: 'mochila viajero',
        hits: 23,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'body',
    hits: 945,
    metadata: null,
    termsList: [
      {
        term: 'body',
        hits: 945,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'baggy',
    hits: 903,
    metadata: null,
    termsList: [
      {
        term: 'baggy',
        hits: 808,
        metadata: null
      },
      {
        term: 'pantalon baggy',
        hits: 77,
        metadata: null
      },
      {
        term: 'malla baggy',
        hits: 18,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'short deportivo',
    hits: 895,
    metadata: null,
    termsList: [
      {
        term: 'short deportivo',
        hits: 531,
        metadata: null
      },
      {
        term: 'short deportivo mujer',
        hits: 117,
        metadata: null
      },
      {
        term: 'short deportivo hombre',
        hits: 92,
        metadata: null
      },
      {
        term: 'short pollero deportivo',
        hits: 63,
        metadata: null
      },
      {
        term: 'short pollera deportivo',
        hits: 58,
        metadata: null
      },
      {
        term: 'short deportivo dama',
        hits: 34,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'remera algodon',
    hits: 879,
    metadata: null,
    termsList: [
      {
        term: 'remera algodon',
        hits: 508,
        metadata: null
      },
      {
        term: 'remera de algodon',
        hits: 127,
        metadata: null
      },
      {
        term: 'remera algodon peinado',
        hits: 52,
        metadata: null
      },
      {
        term: 'remera bordado',
        hits: 36,
        metadata: null
      },
      {
        term: 'remera algodon liso',
        hits: 34,
        metadata: null
      },
      {
        term: 'remera bordada',
        hits: 26,
        metadata: null
      },
      {
        term: 'remera hombr',
        hits: 25,
        metadata: null
      },
      {
        term: 'remera liso algodon',
        hits: 20,
        metadata: null
      },
      {
        term: 'remera liso de algodon',
        hits: 19,
        metadata: null
      },
      {
        term: 'remera bordo',
        hits: 16,
        metadata: null
      },
      {
        term: 'remera broderi',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'short jean',
    hits: 874,
    metadata: null,
    termsList: [
      {
        term: 'short jean',
        hits: 330,
        metadata: null
      },
      {
        term: 'short playero',
        hits: 263,
        metadata: null
      },
      {
        term: 'short rustico',
        hits: 154,
        metadata: null
      },
      {
        term: 'short cey',
        hits: 52,
        metadata: null
      },
      {
        term: 'short irun',
        hits: 29,
        metadata: null
      },
      {
        term: 'short alo',
        hits: 27,
        metadata: null
      },
      {
        term: 'short rayado',
        hits: 19,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'conjunto sastrero',
    hits: 873,
    metadata: null,
    termsList: [
      {
        term: 'conjunto sastrero',
        hits: 483,
        metadata: null
      },
      {
        term: 'sastrero',
        hits: 390,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'pechera',
    hits: 865,
    metadata: null,
    termsList: [
      {
        term: 'pechera',
        hits: 586,
        metadata: null
      },
      {
        term: 'pechera arciel',
        hits: 57,
        metadata: null
      },
      {
        term: 'pechero arciel',
        hits: 49,
        metadata: null
      },
      {
        term: 'pechero maestra',
        hits: 41,
        metadata: null
      },
      {
        term: 'pechera de nene',
        hits: 34,
        metadata: null
      },
      {
        term: 'pechera de nena',
        hits: 33,
        metadata: null
      },
      {
        term: 'pechero nene',
        hits: 25,
        metadata: null
      },
      {
        term: 'pechero nena',
        hits: 22,
        metadata: null
      },
      {
        term: 'pechera nena',
        hits: 18,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'short lino',
    hits: 838,
    metadata: null,
    termsList: [
      {
        term: 'short lino',
        hits: 187,
        metadata: null
      },
      {
        term: 'short de lino',
        hits: 181,
        metadata: null
      },
      {
        term: 'short pollero jean',
        hits: 147,
        metadata: null
      },
      {
        term: 'short engomado',
        hits: 112,
        metadata: null
      },
      {
        term: 'short pollero lino',
        hits: 87,
        metadata: null
      },
      {
        term: 'short pollero de lino',
        hits: 41,
        metadata: null
      },
      {
        term: 'short pollero engomado',
        hits: 27,
        metadata: null
      },
      {
        term: 'short lino cey',
        hits: 20,
        metadata: null
      },
      {
        term: 'pollero short jean',
        hits: 19,
        metadata: null
      },
      {
        term: 'short pollera jean',
        hits: 17,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'vestido corto',
    hits: 821,
    metadata: null,
    termsList: [
      {
        term: 'vestido corto',
        hits: 374,
        metadata: null
      },
      {
        term: 'vestido volado',
        hits: 69,
        metadata: null
      },
      {
        term: 'vestido encaje',
        hits: 59,
        metadata: null
      },
      {
        term: 'vestido de noche',
        hits: 45,
        metadata: null
      },
      {
        term: 'vestido rayado',
        hits: 42,
        metadata: null
      },
      {
        term: 'vestido con volado',
        hits: 31,
        metadata: null
      },
      {
        term: 'vestido azul',
        hits: 29,
        metadata: null
      },
      {
        term: 'vestido sastrero',
        hits: 27,
        metadata: null
      },
      {
        term: 'vestido especial',
        hits: 26,
        metadata: null
      },
      {
        term: 'vestido acampanado',
        hits: 22,
        metadata: null
      },
      {
        term: 'vestido noche',
        hits: 21,
        metadata: null
      },
      {
        term: 'vestido estampado',
        hits: 20,
        metadata: null
      },
      {
        term: 'vestido al cuerpo',
        hits: 19,
        metadata: null
      },
      {
        term: 'vestido de encaje',
        hits: 19,
        metadata: null
      },
      {
        term: 'vestido civil',
        hits: 18,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'camisa',
    hits: 812,
    metadata: null,
    termsList: [
      {
        term: 'camisa',
        hits: 618,
        metadata: null
      },
      {
        term: 'camisaco',
        hits: 135,
        metadata: null
      },
      {
        term: 'camisa negro',
        hits: 41,
        metadata: null
      },
      {
        term: 'camisaco jean',
        hits: 18,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'cartera',
    hits: 802,
    metadata: null,
    termsList: [
      {
        term: 'cartera',
        hits: 738,
        metadata: null
      },
      {
        term: 'cartera grande',
        hits: 28,
        metadata: null
      },
      {
        term: 'cartera importado',
        hits: 19,
        metadata: null
      },
      {
        term: 'bolso cartera',
        hits: 17,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'conjunto hombre',
    hits: 796,
    metadata: null,
    termsList: [
      {
        term: 'conjunto hombre',
        hits: 165,
        metadata: null
      },
      {
        term: 'conjunto de hombre',
        hits: 126,
        metadata: null
      },
      {
        term: 'ojota hombre',
        hits: 77,
        metadata: null
      },
      {
        term: 'pantalon sastrero hombre',
        hits: 61,
        metadata: null
      },
      {
        term: 'ropa de hombre',
        hits: 60,
        metadata: null
      },
      {
        term: 'ojota de hombre',
        hits: 49,
        metadata: null
      },
      {
        term: 'cinto de hombre',
        hits: 48,
        metadata: null
      },
      {
        term: 'pantalon de hombre',
        hits: 37,
        metadata: null
      },
      {
        term: 'pantalon de vestir hombre',
        hits: 36,
        metadata: null
      },
      {
        term: 'pantalon hombre',
        hits: 36,
        metadata: null
      },
      {
        term: 'borcego hombre',
        hits: 31,
        metadata: null
      },
      {
        term: 'saco hombre',
        hits: 26,
        metadata: null
      },
      {
        term: 'sastrero hombre',
        hits: 26,
        metadata: null
      },
      {
        term: 'saco de hombre',
        hits: 18,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'pareo',
    hits: 795,
    metadata: null,
    termsList: [
      {
        term: 'pareo',
        hits: 643,
        metadata: null
      },
      {
        term: 'vestido pareo',
        hits: 55,
        metadata: null
      },
      {
        term: 'pareo corto',
        hits: 35,
        metadata: null
      },
      {
        term: 'pareo tul',
        hits: 24,
        metadata: null
      },
      {
        term: 'conjunto pareo',
        hits: 19,
        metadata: null
      },
      {
        term: 'pareo de tul',
        hits: 19,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'playa',
    hits: 786,
    metadata: null,
    termsList: [
      {
        term: 'playa',
        hits: 276,
        metadata: null
      },
      {
        term: 'vestido playa',
        hits: 130,
        metadata: null
      },
      {
        term: 'vestido de playa',
        hits: 85,
        metadata: null
      },
      {
        term: 'conjunto playa',
        hits: 77,
        metadata: null
      },
      {
        term: 'lona de playa',
        hits: 42,
        metadata: null
      },
      {
        term: 'conjunto de playa',
        hits: 39,
        metadata: null
      },
      {
        term: 'bolso de playa',
        hits: 31,
        metadata: null
      },
      {
        term: 'ropa de playa',
        hits: 27,
        metadata: null
      },
      {
        term: 'lona playa',
        hits: 23,
        metadata: null
      },
      {
        term: 'bolso playa',
        hits: 22,
        metadata: null
      },
      {
        term: 'pollera playa',
        hits: 18,
        metadata: null
      },
      {
        term: 'vestido para playa',
        hits: 16,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'juego de sabana',
    hits: 782,
    metadata: null,
    termsList: [
      {
        term: 'juego de sabana',
        hits: 351,
        metadata: null
      },
      {
        term: 'sabana',
        hits: 298,
        metadata: null
      },
      {
        term: 'sabana ajustabl',
        hits: 32,
        metadata: null
      },
      {
        term: 'sabana piñata',
        hits: 27,
        metadata: null
      },
      {
        term: 'sabana casatex',
        hits: 19,
        metadata: null
      },
      {
        term: 'sabana liso',
        hits: 19,
        metadata: null
      },
      {
        term: 'sabanas algodon',
        hits: 19,
        metadata: null
      },
      {
        term: 'sabana cuna',
        hits: 17,
        metadata: null
      }
    ]
  },
  {
    idTenant: 1,
    cluster: 'camiseta de futbol',
    hits: 772,
    metadata: null,
    termsList: [
      {
        term: 'camiseta de futbol',
        hits: 522,
        metadata: null
      },
      {
        term: 'camiseta futbol',
        hits: 107,
        metadata: null
      },
      {
        term: 'remera de futbol',
        hits: 71,
        metadata: null
      },
      {
        term: 'remera futbol',
        hits: 34,
        metadata: null
      },
      {
        term: 'camiseta de futbol importado',
        hits: 19,
        metadata: null
      },
      {
        term: 'musculosa futbol',
        hits: 19,
        metadata: null
      }
    ]
  }
]
